<ldw-document-toolbar [document]="document" [isReadOnly]="true" [showBookmark]="false"
                      (closeSelected)="closeDetail()"></ldw-document-toolbar>
<ldw-document-view [document]="document" [readOnly]="true" [isDetail]='true' [search]='search'></ldw-document-view>

